import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/exif',
    name: 'exif',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Exif.vue')
  },
  {
    path: '/sales',
    name: 'sales',
    // барахолка: карточки из /sales-data/items.json (пишет телеграм-бот)
    component: () => import(/* webpackChunkName: "sales" */ '../views/SalesView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
